import React from "react";
import { Link } from "react-router-dom";

export default class About extends React.Component {
  componentDidMount() {
    const $ = window.$;

    if ($(".video-popup").length) {
      $(".video-popup").magnificPopup({
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: true,

        fixedContentPos: false,
      });
    }
  }
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <div id="about" className="about-three">
          <div className="container">
            <div className="row">
              <div className="col-xl-6">
                <div className="about-three__img">
                  <div className="inner">
                    <img
                      src={
                        publicUrl + "assets/images/update1.0/about-v3-img1.jpg"
                      }
                      alt="#"
                    />
                    {/* <div
                      className="about-three__img-video wow zoomIn"
                      data-wow-delay="100ms"
                    >
                      <a
                        href="https://www.youtube.com/watch?v=0O2aH4XLbto"
                        className="video-popup"
                      >
                        <div className="about-three__img-video-icon">
                          <span className="fa fa-play"></span>
                          <i className="ripple"></i>
                        </div>
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className="col-xl-6">
                <div className="about-three__content">
                  <div className="sec-title">
                    <div className="sec-title__tagline">
                      <h6> O NAMA </h6> <span className="right"></span>
                    </div>
                    <h2 className="sec-title__title">
                      Gradnja poslovnih i stambenih objekata
                    </h2>
                  </div>

                  <div className="about-three__content-inner">
                    <div className="text1">
                      <p>
                        Tradicijom poslovanja dugom 25 godina, gradimo i
                        adaptiramo stambene i poslovne objekte s naglaskom na
                        kvalitet, pouzdanost i dugotrajna rješenja. Naša misija
                        je pružiti čvrstu osnovu svakom projektu, spajajući
                        funkcionalnost i estetski sklad – bilo da se radi o
                        novogradnji, renoviranju ili dizajnu prostora.
                      </p>
                    </div>
                    <div className="text2">
                      <h4>
                        Radimo precizno, odgovorno i s jasnim ciljem – da svaki
                        prostor pretvorimo u trajnu vrijednost.
                      </h4>
                    </div>
                    <ul className="about-three__content-list">
                      <li>
                        <div className="icon-box">
                          <span className="icon-tick"></span>
                        </div>
                        <div className="text-box">
                          <p> Paketi za unutrašnji dizajn</p>
                        </div>
                      </li>
                      <li>
                        <div className="icon-box">
                          <span className="icon-tick"></span>
                        </div>
                        <div className="text-box">
                          <p> Renovacija stambenih i poslovnih prostora</p>
                        </div>
                      </li>
                      <li>
                        <div className="icon-box">
                          <span className="icon-tick"></span>
                        </div>
                        <div className="text-box">
                          <p>Popravka i sanacija stambenih krovova</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
